import { useNavigate } from "react-router-dom";

interface LoginPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
}

const LoginPromptModal = ({
  isOpen,
  onClose,
  message = "이 기능을 이용하려면 로그인이 필요합니다",
}: LoginPromptModalProps) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleKakaoLogin = () => {
    window.open(`${process.env.REACT_APP_API_URL}/auth/user/login/kakao`, '_self');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40 animate-fadeIn"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl p-8 max-w-[400px] w-full mx-4 animate-scaleIn shadow-float">
        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full hover:bg-achromatic-100 transition-colors text-achromatic-400"
        >
          ✕
        </button>

        {/* Content */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#FEE500]/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-2xl">☕</span>
          </div>
          <h2 className="text-lg font-bold text-achromatic-900 mb-2">
            로그인이 필요합니다
          </h2>
          <p className="text-sm text-achromatic-400 leading-relaxed">
            {message}
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-3">
          <button
            onClick={handleKakaoLogin}
            className="flex items-center justify-center gap-2 w-full py-3.5 bg-[#FEE500] rounded-xl text-sm font-bold text-[#3C1E1E] hover:brightness-[0.97] transition-all active:scale-[0.98]"
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M9 1C4.58 1 1 3.79 1 7.2c0 2.16 1.46 4.07 3.66 5.17-.16.58-.58 2.1-.67 2.43-.1.4.15.4.31.29.13-.09 2.04-1.38 2.87-1.94.59.09 1.2.13 1.83.13 4.42 0 8-2.79 8-6.2S13.42 1 9 1z" fill="#3C1E1E" />
            </svg>
            카카오로 시작하기
          </button>
          <button
            onClick={() => navigate("/explore")}
            className="w-full py-3 text-sm font-medium text-achromatic-400 hover:text-achromatic-600 transition-colors"
          >
            먼저 둘러보기 →
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPromptModal;
